import { Product } from '../types';

// ============================================
// ECM CONNECTORS (ENGINE CONTROL MODULE)
// ============================================

// ECM CONNECTORS - HIGH DENSITY (24-94 POLE)
export const ecmConnectorProducts: Product[] = [
  {
    id: "ecm-conn-al-24p-f-5mm-15in",
    name: "Ashok Leyland 24 Pole Female ECM - 5mm Wire (15\" Long)",
    slug: "ecm-al-24-pole-female-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 24 pole female ECM connector with 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2109951",
    image: "/products/ecm-connectors/ecm/SH2109951.jpg",
    featured: true,
    specifications: {
      "Poles": "24 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "24-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM", "Engine Control Module"],
  },
  {
    id: "ecm-conn-al-24p-m-5mm-15in",
    name: "Ashok Leyland 24 Pole Male ECM - 5mm Wire (15\" Long)",
    slug: "ecm-al-24-pole-male-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 24 pole male ECM connector with 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2109952",
    image: "/products/ecm-connectors/ecm/SH2109952.jpg",
    featured: true,
    specifications: {
      "Poles": "24 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "24-pole", "ashok-leyland", "male", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-26p-f-ecm-5mm-15in",
    name: "Ashok Leyland 26 Pole Female ECM - ECM & 5mm Wire (15\" Long)",
    slug: "ecm-al-26-pole-female-ecm-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 26 pole female ECM connector with ECM special & 5mm wire. 15 inch long.",
    partNumber: "SH2109963",
    image: "/products/ecm-connectors/ecm/SH2109963.jpg",
    specifications: {
      "Poles": "26 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special & 5mm Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "26-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-tata-ecm-small-40p-f-15in",
    name: "Tata ECM Small 40 Pole Female - ECM & 6mm Wire (15\" Long)",
    slug: "ecm-tata-small-40-pole-female-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Tata ECM small 40 pole female connector with ECM special & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109942",
    image: "/products/ecm-connectors/ecm/SH2109942.jpg",
    featured: true,
    specifications: {
      "Poles": "40 Pole",
      "Gender": "Female",
      "Compatible": "Tata ECM Small",
      "Wire Type": "ECM Special & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "40-pole", "tata", "small", "female", "long-wire"],
    applications: ["Tata ECM Small", "Engine Control"],
  },
  {
    id: "ecm-conn-al-new-model-44p-f-15in",
    name: "Ashok Leyland New Model 44 Pole Female ECM (15\" Long)",
    slug: "ecm-al-new-model-44-pole-female-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland new model 44 pole female ECM connector with ECM special & 4mm deluxe wire. 15 inch long.",
    partNumber: "SH2104401",
    image: "/products/ecm-connectors/ecm/SH2104401.jpg",
    featured: true,
    specifications: {
      "Poles": "44 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "ECM Special & 4mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "44-pole", "ashok-leyland", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "ECM"],
  },
  {
    id: "ecm-conn-tata-48p-f-15in-1",
    name: "Tata 48 Pole Female ECM - ECM & 4mm Wire (15\" Long)",
    slug: "ecm-tata-48-pole-female-15in-1",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Tata 48 pole female ECM connector with ECM special & 4mm deluxe wire. 15 inch long.",
    partNumber: "SH2104801",
    image: "/products/ecm-connectors/ecm/SH2104801.jpg",
    featured: true,
    specifications: {
      "Poles": "48 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special & 4mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "48-pole", "tata", "female", "long-wire"],
    applications: ["Tata", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-48p-f-15in",
    name: "Ashok Leyland & Tata 48 Pole Female ECM (15\" Long)",
    slug: "ecm-al-tata-48-pole-female-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata 48 pole female ECM connector with ECM special & 4mm deluxe wire. 15 inch long.",
    partNumber: "SH2104802",
    image: "/products/ecm-connectors/ecm/SH2104802.jpg",
    featured: true,
    specifications: {
      "Poles": "48 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "ECM Special & 4mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "48-pole", "ashok-leyland", "tata", "female", "long-wire"],
    applications: ["Ashok Leyland", "Tata", "ECM"],
  },
  {
    id: "ecm-conn-tata-48p-f-15in-2",
    name: "Tata 48 Pole Female ECM - ECM & 4mm Wire (15\" Long) Type 2",
    slug: "ecm-tata-48-pole-female-15in-2",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Tata 48 pole female ECM connector with ECM special & 4mm deluxe wire. 15 inch long.",
    partNumber: "SH2104803",
    image: "/products/ecm-connectors/ecm/SH2104803.jpg",
    specifications: {
      "Poles": "48 Pole",
      "Gender": "Female",
      "Compatible": "Tata",
      "Wire Type": "ECM Special & 4mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "48-pole", "tata", "female", "long-wire"],
    applications: ["Tata", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-48p-f-ecm-8-6mm-15in",
    name: "Ashok Leyland & Tata 48 Pole Female ECM - 8mm & 6mm (15\" Long)",
    slug: "ecm-al-tata-48-pole-female-8-6mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata 48 pole female ECM connector with ECM special, 8mm & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109953",
    image: "/products/ecm-connectors/ecm/SH2109953.jpg",
    featured: true,
    specifications: {
      "Poles": "48 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "ECM Special, 8mm & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "48-pole", "ashok-leyland", "tata", "female", "heavy-duty", "long-wire"],
    applications: ["Ashok Leyland", "Tata", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-48p-m-ecm-8-6mm-15in",
    name: "Ashok Leyland & Tata 48 Pole Male ECM - 8mm & 6mm (15\" Long)",
    slug: "ecm-al-tata-48-pole-male-8-6mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata 48 pole male ECM connector with ECM special, 8mm & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109954",
    image: "/products/ecm-connectors/ecm/SH2109954.jpg",
    featured: true,
    specifications: {
      "Poles": "48 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "ECM Special, 8mm & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "48-pole", "ashok-leyland", "tata", "male", "heavy-duty", "long-wire"],
    applications: ["Ashok Leyland", "Tata", "ECM"],
  },
  {
    id: "ecm-conn-al-52p-f-ecm-5mm-15in",
    name: "Ashok Leyland 52 Pole Female ECM - ECM & 5mm Wire (15\" Long)",
    slug: "ecm-al-52-pole-female-ecm-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 52 pole female ECM connector with ECM special & 5mm wire. 15 inch long.",
    partNumber: "SH2109949",
    image: "/products/ecm-connectors/ecm/SH2109949.jpg",
    featured: true,
    specifications: {
      "Poles": "52 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special & 5mm Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "52-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-53p-f-ecm-4-5mm-15in",
    name: "Ashok Leyland 53 Pole Female ECM - 4mm & 5mm (15\" Long)",
    slug: "ecm-al-53-pole-female-ecm-4-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 53 pole female ECM connector with ECM special, 4mm & 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2109957",
    image: "/products/ecm-connectors/ecm/SH2109957.jpg",
    featured: true,
    specifications: {
      "Poles": "53 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special, 4mm & 5mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "53-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-32p-f-ecm-15in",
    name: "Ashok Leyland 32 Pole Female ECM - ECM Special Wire (15\" Long)",
    slug: "ecm-al-32-pole-female-ecm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 32 pole female ECM connector with ECM special wire. 15 inch long.",
    partNumber: "SH2109959",
    image: "/products/ecm-connectors/ecm/SH2109959.jpg",
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "32-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-60p-f-ecm-15in-1",
    name: "Ashok Leyland 60 Pole Female ECM - ECM Special Wire (15\" Long)",
    slug: "ecm-al-60-pole-female-ecm-15in-1",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 60 pole female ECM connector with ECM special wire. 15 inch long.",
    partNumber: "SH2109961",
    image: "/products/ecm-connectors/ecm/SH2109961.jpg",
    featured: true,
    specifications: {
      "Poles": "60 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "60-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-new-model-60p-f-ecm-15in",
    name: "Ashok Leyland ECM New Model 60 Pole Female (15\" Long)",
    slug: "ecm-al-new-model-60-pole-female-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland ECM new model 60 pole female connector with ECM special wire. 15 inch long.",
    partNumber: "SH2106001",
    image: "/products/ecm-connectors/ecm/SH2106001.jpg",
    featured: true,
    specifications: {
      "Poles": "60 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland ECM New Model",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "60-pole", "ashok-leyland", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-new-model-60p-f-ecm-5mm-15in",
    name: "Ashok Leyland & Tata ECM New Model 60 Pole Female - 5mm (15\" Long)",
    slug: "ecm-al-tata-new-model-60-pole-female-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata ECM new model 60 pole female connector with ECM special & 5mm wire. 15 inch long.",
    partNumber: "SH2106002",
    image: "/products/ecm-connectors/ecm/SH2106002.jpg",
    featured: true,
    specifications: {
      "Poles": "60 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata ECM New Model",
      "Wire Type": "ECM Special & 5mm Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "60-pole", "ashok-leyland", "tata", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-new-model-60p-f-ecm-5mm-15in-2",
    name: "Ashok Leyland & Tata ECM New Model 60 Pole Female - 5mm Type 2 (15\" Long)",
    slug: "ecm-al-tata-new-model-60-pole-female-5mm-15in-2",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata ECM new model 60 pole female connector with ECM special & 5mm wire. 15 inch long.",
    partNumber: "SH2106003",
    image: "/products/ecm-connectors/ecm/SH2106003.jpg",
    specifications: {
      "Poles": "60 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata ECM New Model",
      "Wire Type": "ECM Special & 5mm Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "60-pole", "ashok-leyland", "tata", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "ecm-conn-al-62p-f-ecm-5mm-15in",
    name: "Ashok Leyland 62 Pole Female ECM - ECM & 5mm (15\" Long)",
    slug: "ecm-al-62-pole-female-ecm-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 62 pole female ECM connector with ECM special & 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2109940",
    image: "/products/ecm-connectors/ecm/SH2109940.jpg",
    featured: true,
    specifications: {
      "Poles": "62 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special & 5mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "62-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-al-62p-m-ecm-5mm-15in",
    name: "Ashok Leyland 62 Pole Male ECM - ECM & 5mm (15\" Long)",
    slug: "ecm-al-62-pole-male-ecm-5mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 62 pole male ECM connector with ECM special & 5mm deluxe wire. 15 inch long.",
    partNumber: "SH2109921",
    image: "/products/ecm-connectors/ecm/SH2109921.jpg",
    featured: true,
    specifications: {
      "Poles": "62 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special & 5mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "62-pole", "ashok-leyland", "male", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
  {
    id: "ecm-conn-tata-ecm-big-81p-f-15in",
    name: "Tata ECM Big 81 Pole Female - ECM & 6mm (15\" Long)",
    slug: "ecm-tata-big-81-pole-female-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Tata ECM big 81 pole female connector with ECM special & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109945",
    image: "/products/ecm-connectors/ecm/SH2109945.jpg",
    featured: true,
    specifications: {
      "Poles": "81 Pole",
      "Gender": "Female",
      "Compatible": "Tata ECM Big",
      "Wire Type": "ECM Special & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "81-pole", "tata", "big", "female", "long-wire"],
    applications: ["Tata ECM Big", "Engine Control"],
  },
  {
    id: "ecm-conn-al-tata-new-model-94p-f-ecm-6mm-15in",
    name: "Ashok Leyland & Tata ECM New Model 94 Pole Female - 6mm (15\" Long)",
    slug: "ecm-al-tata-new-model-94-pole-female-6mm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata ECM new model 94 pole female connector with ECM special & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109401",
    image: "/products/ecm-connectors/ecm/SH2109401.jpg",
    featured: true,
    specifications: {
      "Poles": "94 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata ECM New Model",
      "Wire Type": "ECM Special & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "94-pole", "ashok-leyland", "tata", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "ecm-conn-al-tata-new-model-94p-f-ecm-6mm-15in-2",
    name: "Ashok Leyland & Tata ECM New Model 94 Pole Female - 6mm Type 2 (15\" Long)",
    slug: "ecm-al-tata-new-model-94-pole-female-6mm-15in-2",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland & Tata ECM new model 94 pole female connector with ECM special & 6mm deluxe wire. 15 inch long.",
    partNumber: "SH2109402",
    image: "/products/ecm-connectors/ecm/SH2109402.jpg",
    featured: true,
    specifications: {
      "Poles": "94 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland & Tata ECM New Model",
      "Wire Type": "ECM Special & 6mm Deluxe",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "94-pole", "ashok-leyland", "tata", "new-model", "female", "long-wire"],
    applications: ["Ashok Leyland New Model", "Tata New Model", "ECM"],
  },
  {
    id: "ecm-conn-al-28p-f-ecm-15in",
    name: "Ashok Leyland 28 Pole Female ECM - ECM Special Wire (15\" Long)",
    slug: "ecm-al-28-pole-female-ecm-15in",
    category: "ECM Connectors",
    subcategory: "ECM High Density",
    description: "Ashok Leyland 28 pole female ECM connector with ECM special wire. 15 inch long.",
    partNumber: "SH2109901",
    image: "/products/ecm-connectors/ecm/SH2109901.jpg",
    specifications: {
      "Poles": "28 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "15 inches",
      "Application": "ECM (Engine Control Module)",
      "Packing": "10 Pcs",
    },
    tags: ["ecm", "connector", "28-pole", "ashok-leyland", "female", "long-wire"],
    applications: ["Ashok Leyland", "ECM"],
  },
];
